// extracted by mini-css-extract-plugin
export default {"edgeBacking":"K1HierarchyEdge_edgeBacking__V43K1"};